import { render, staticRenderFns } from "./TimelineBody.vue?vue&type=template&id=fe9bb6be&scoped=true"
import script from "./TimelineBody.vue?vue&type=script&lang=ts"
export * from "./TimelineBody.vue?vue&type=script&lang=ts"
import style0 from "./TimelineBody.vue?vue&type=style&index=0&id=fe9bb6be&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9bb6be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fe9bb6be')) {
      api.createRecord('fe9bb6be', component.options)
    } else {
      api.reload('fe9bb6be', component.options)
    }
    module.hot.accept("./TimelineBody.vue?vue&type=template&id=fe9bb6be&scoped=true", function () {
      api.rerender('fe9bb6be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/TimelineBody.vue"
export default component.exports